const SHARED_CTA_LINKS = [
  { to: '/pre-owned-items', label: 'Browse pre-owned items' },
  { to: '/buy/clothing', label: 'Shop used clothing' },
  { to: '/what-to-offer', label: 'Sell an item on Flea' },
];

export const SEO_LANDING_PAGES = {
  'second-hand-egypt': {
    slug: 'second-hand-egypt',
    english: {
      title: 'Second-Hand Marketplace in Egypt | Buy & Sell Used Items | Flea',
      description: 'Buy and sell second-hand items in Egypt on Flea. Browse pre-owned fashion, furniture, books, home goods, and more from sellers across Egypt.',
      keywords: 'second hand Egypt, second-hand marketplace Egypt, used items Egypt, pre-owned items Cairo, buy sell used items Egypt',
      h1: 'Second-Hand Marketplace in Egypt',
      intro: 'Discover useful pre-owned fashion, furniture, books, and home goods from people across Egypt. Give great items a second life and list the things you no longer use.',
      sections: [
        { heading: 'Find second-hand items near you', body: 'Browse everyday pre-owned finds in categories such as clothing, bags, furniture, books, sports, and home goods. Flea makes it simpler to shop thoughtfully and reduce waste.' },
        { heading: 'Sell used items with confidence', body: 'Create a listing with clear photos and honest details, then connect with buyers through Flea. Your listing can help another person find exactly what they need.' },
      ],
      faqs: [
        { question: 'What can I buy second-hand on Flea?', answer: 'You can browse pre-owned fashion, furniture, books, home goods, accessories, sports items, and more from sellers in Egypt.' },
        { question: 'Can I sell my used items on Flea?', answer: 'Yes. Create a listing with accurate photos, a description, and a fair price so buyers can discover your item.' },
      ],
      ctaLinks: SHARED_CTA_LINKS,
    },
    arabic: {
      title: 'سوق السلع المستعملة في مصر | شراء وبيع المستعمل | فلي',
      description: 'اشتري وبِع السلع المستعملة في مصر على فلي. اكتشف الملابس والأثاث والكتب والأدوات المنزلية المستعملة من بائعين في أنحاء مصر.',
      keywords: 'مستعمل مصر, سوق المستعمل, بالة, باله, شراء وبيع مستعمل, سلع مستعملة القاهرة',
      h1: 'سوق السلع المستعملة في مصر',
      intro: 'اكتشف ملابس وأثاث وكتب وأدوات منزلية مستعملة بحالة جيدة من أشخاص في أنحاء مصر. ادّي للحاجات عمر جديد واعرض الأشياء التي لم تعد تحتاجها.',
      sections: [
        { heading: 'اشتري بالة ومستعمل قريب منك', body: 'تصفح الملابس والشنط والأثاث والكتب والأدوات المنزلية والرياضية المستعملة. سواء كنت تبحث عن بالة أو مستعمل بحالة جيدة، ستجد اختيارات متنوعة على فلي.' },
        { heading: 'بِع حاجاتك المستعملة بثقة', body: 'أضف صوراً واضحة ووصفاً صادقاً وسعراً مناسباً. إعلانك قد يساعد شخصاً آخر على العثور على ما يحتاجه بدلاً من شراء شيء جديد.' },
      ],
      faqs: [
        { question: 'ما الذي يمكن شراؤه مستعملاً على فلي؟', answer: 'يمكنك تصفح الملابس والأثاث والكتب والأدوات المنزلية والشنط والإكسسوارات وغيرها من السلع المستعملة في مصر.' },
        { question: 'هل يمكنني بيع البالة أو أغراضي المستعملة على فلي؟', answer: 'نعم، أضف إعلاناً بصور واضحة ووصف دقيق وسعر عادل ليصل إلى المشترين.' },
      ],
      ctaLinks: [
        { to: '/pre-owned-items', label: 'تصفح المستعمل' },
        { to: '/buy/clothing', label: 'تسوق ملابس مستعملة' },
        { to: '/buy/clothing', label: 'تسوق ملابس مستعملة' },
        { to: '/what-to-offer', label: 'اعرض غرضاً للبيع' },
      ],
    },
  },
  'thrift-egypt': {
    slug: 'thrift-egypt',
    english: {
      title: 'Thrift Shopping in Egypt | Pre-Loved Finds | Flea Marketplace',
      description: 'Explore thrift and pre-loved finds in Egypt on Flea. Shop second-hand clothes, accessories, books, furniture, and unique everyday items.',
      keywords: 'thrift Egypt, thrifting Egypt, thrift shop Cairo, thrift clothes Egypt, pre-loved fashion Egypt',
      h1: 'Thrift Shopping and Pre-Loved Finds in Egypt',
      intro: 'Thrifting is a practical way to discover unique items, save money, and keep useful things in circulation. Explore pre-loved finds from sellers across Egypt.',
      sections: [
        { heading: 'Make every thrift find count', body: 'Find one-of-a-kind clothing, accessories, books, and home pieces with character. Each pre-loved item is a chance to choose something useful with less waste.' },
        { heading: 'A thrift marketplace beyond fashion', body: 'Flea is not only for thrift clothes. Browse furniture, games, sports equipment, tools, and more when you want a smart second-hand alternative.' },
      ],
      faqs: [
        { question: 'What does thrifting mean on Flea?', answer: 'Thrifting means discovering useful, pre-loved items instead of buying new. Flea brings together second-hand listings from sellers in Egypt.' },
        { question: 'Can I find more than clothes while thrifting?', answer: 'Yes. Flea includes categories such as furniture, books, home goods, sports, games, and accessories.' },
      ],
      ctaLinks: SHARED_CTA_LINKS,
    },
    arabic: {
      title: 'ثريفت وبالة في مصر | اكتشف قطعاً مستعملة مميزة | فلي',
      description: 'اكتشف الثريفت والبالة والقطع المستعملة المميزة في مصر على فلي. تسوق ملابس وشنط وكتب وأثاث وأغراضاً يومية بحالة جيدة.',
      keywords: 'ثريفت مصر, ملابس ثريفت, بالة مصر, باله, ملابس مستعملة القاهرة, سوق المستعمل',
      h1: 'ثريفت وبالة وقطع مستعملة مميزة في مصر',
      intro: 'الثريفت طريقة ذكية لاكتشاف قطع مميزة وتوفير المال والحفاظ على الأشياء المفيدة في الاستخدام. تصفح البالة والقطع المستعملة من بائعين في مصر.',
      sections: [
        { heading: 'اكتشف قطع ثريفت مميزة', body: 'ابحث عن ملابس وشنط وكتب وقطع منزلية لها طابع خاص. كل قطعة بالة أو ثريفت يمكن أن تكون اختياراً مفيداً وأقل هدراً.' },
        { heading: 'الثريفت ليس للملابس فقط', body: 'على فلي ستجد أيضاً أثاثاً وكتباً وألعاباً وأدوات رياضية وأدوات منزلية مستعملة، وليس ملابس ثريفت فقط.' },
      ],
      faqs: [
        { question: 'ما معنى ثريفت على فلي؟', answer: 'الثريفت هو اكتشاف سلع مستعملة أو بالة بحالة جيدة بدلاً من شراء الجديد. يجمع فلي إعلانات من بائعين في مصر.' },
        { question: 'هل توجد بالة غير الملابس؟', answer: 'نعم، يمكنك تصفح الأثاث والكتب والأدوات المنزلية والرياضة والألعاب والإكسسوارات أيضاً.' },
      ],
      ctaLinks: [
        { to: '/pre-owned-items', label: 'اكتشف الثريفت والمستعمل' },
        { to: '/buy/clothing', label: 'تصفح ملابس ثريفت' },
        { to: '/buy/accessories', label: 'تصفح شنط وإكسسوارات' },
        { to: '/what-to-offer', label: 'اعرض قطعة للبيع' },
      ],
    },
  },
  'flea-market-egypt': {
    slug: 'flea-market-egypt',
    english: {
      title: 'Flea Market in Egypt | Buy & Sell Pre-Owned Items | Flea',
      description: 'Flea is an online flea market in Egypt for buying and selling pre-owned fashion, furniture, books, home goods, and unique finds.',
      keywords: 'flea market Egypt, online flea market Cairo, flea marketplace Egypt, buy sell used items Egypt, pre-owned market',
      h1: 'An Online Flea Market for Egypt',
      intro: 'Flea brings the variety of a flea market online: useful pre-owned items, unique finds, and a simple place to buy, sell, and exchange across Egypt.',
      sections: [
        { heading: 'Explore a flea market from anywhere', body: 'Browse a changing selection of fashion, furniture, books, home goods, and more. New listings give you a reason to check back for your next find.' },
        { heading: 'Turn unused items into someone else’s find', body: 'List items you no longer need and help them reach a new home. Flea connects people looking to buy, sell, and exchange thoughtfully in Egypt.' },
      ],
      faqs: [
        { question: 'Is Flea an online flea market?', answer: 'Yes. Flea is an online marketplace in Egypt where people can browse, buy, sell, and exchange pre-owned and unique items.' },
        { question: 'What can I find on Flea Marketplace?', answer: 'You can find fashion, bags, furniture, books, home goods, sports items, and many other second-hand listings.' },
      ],
      ctaLinks: SHARED_CTA_LINKS,
    },
    arabic: {
      title: 'فلي ماركت وسوق المستعمل في مصر | شراء وبيع على فلي',
      description: 'فلي هو فلي ماركت أونلاين وسوق للمستعمل في مصر. اشتري وبِع الملابس والأثاث والكتب والأدوات المنزلية والقطع المميزة.',
      keywords: 'فلي ماركت مصر, flea market مصر, سوق المستعمل, بالة, باله, فلي ماركت القاهرة, شراء وبيع مستعمل',
      h1: 'فلي ماركت أونلاين وسوق المستعمل في مصر',
      intro: 'فلي يجمع تنوع الفلي ماركت على الإنترنت: سلع مستعملة مفيدة وقطع مميزة ومكان بسيط للشراء والبيع والتبديل في أنحاء مصر.',
      sections: [
        { heading: 'تصفح فلي ماركت من أي مكان', body: 'اكتشف تشكيلة متجددة من الملابس والأثاث والكتب والأدوات المنزلية وغيرها. الإعلانات الجديدة تعطيك فرصة للعثور على قطعة مميزة كل يوم.' },
        { heading: 'حوّل الأشياء غير المستخدمة إلى اكتشاف جديد', body: 'اعرض الأغراض التي لم تعد تحتاجها وساعدها في الوصول إلى بيت جديد. فلي يربط من يريدون الشراء والبيع والتبديل في مصر.' },
      ],
      faqs: [
        { question: 'هل فلي فلي ماركت أونلاين؟', answer: 'نعم. فلي سوق إلكتروني في مصر لتصفح وشراء وبيع وتبديل السلع المستعملة والقطع المميزة.' },
        { question: 'ماذا يمكنني أن أجد في سوق فلي؟', answer: 'يمكنك العثور على الملابس والشنط والأثاث والكتب والأدوات المنزلية والرياضة وغيرها من الإعلانات المستعملة.' },
      ],
      ctaLinks: [
        { to: '/pre-owned-items', label: 'تصفح سوق فلي' },
        { to: '/buy/clothing', label: 'تصفح الملابس والشنط' },
        { to: '/buy/home-garden', label: 'تصفح المنزل والأثاث' },
        { to: '/what-to-offer', label: 'ابدأ البيع على فلي' },
      ],
    },
  },
};

export const SEO_LANDING_PATHS = Object.values(SEO_LANDING_PAGES).flatMap(({ slug }) => [
  `/${slug}`,
  `/ar/${slug}`,
]);

export function getSeoLandingPage(slug) {
  return SEO_LANDING_PAGES[slug] || null;
}
